__turbopack_context__.v({
  "answer": "vpPFWa_answer",
  "assistant": "vpPFWa_assistant",
  "chat": "vpPFWa_chat",
  "composer": "vpPFWa_composer",
  "copilotMark": "vpPFWa_copilotMark",
  "prompt": "vpPFWa_prompt",
  "response": "vpPFWa_response",
  "responseActions": "vpPFWa_responseActions",
  "sources": "vpPFWa_sources",
  "tool": "vpPFWa_tool",
  "transcript": "vpPFWa_transcript",
});
